<template>
  <div v-if="hasParams">
    <div v-if="isDebug" class="debug_str">CR-1 練習１ 検査２ p01</div>

    <!-- ↓ p01 は単独 -->

    <div class="row">

      <div class="col-12 px-3">
        <div class="question_table_wrapper">
          <div class="question_table">
            <div class="question_table_row">
              <div class="question_no range">{{ params[questionIds[0]].q_no }}～{{ params[questionIds[3]].q_no }}</div>
              <MyTextBox class="question_str_90" :canEdit="canEdit" v-model="params.s01" />
            </div>
          </div>
        </div>
        <MyTextBox class="my-3" :isTextarea="true" :canEdit="canEdit" v-model="params.s02" />
      </div>

      <div class="col-12 mt-4 mb-4 px-3">

        <div class="question_tab_wrapper">

          <div class="question_tab_contents">

            <div v-show="currentTabNo==1" :class="`question_tab_content ${questionIds[0]}`"><!-- q016 -->

              <div class="question_table_wrapper">
                <div class="question_table">
                  <div class="question_table_row">
                    <div class="question_no">{{ params[questionIds[0]].q_no }}</div>
                    <div class="text_container_80 bg-lightyellow">
                      <MyTextBox class="_question_str_90" :canEdit="canEdit" v-model="params[questionIds[0]].question" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="choice_table_wrapper ml-md-5">
                <div class="choice_table">
                  <div class="choice_table_row" v-for="(choiceValue, choiceIdx) in choiceValues[0]" :key="choiceValue">
                    <input type="checkbox" :id="`${questionIds[0]}_${choiceValue}`" class="choice_checkbox" :value="choiceValue" :disabled="!canAnswer"
                            v-model="params[questionIds[0]].answer"
                            :ref="`checkbox_q${questionIds[0]}`"
                            @click="onClickCheckbox(params[questionIds[0]], $refs[`checkbox_q${questionIds[0]}`], $event)"
                            @change="sortCheckboxAnswers(params[questionIds[0]])"
                    />
                    <label :for="`${questionIds[0]}_${choiceValue}`" class="choice_checkbox_placeholder has_value">
                      <div class="choice_value">{{ choiceValue }}：</div>
                    </label>
                    <label :for="`${questionIds[0]}_${choiceValue}`" class="">
                      <MyTextBox class="choice_caption" :canEdit="canEdit" v-model="params[questionIds[0]].choices[choiceIdx]" />
                    </label>
                  </div>
                </div>
              </div>

            </div><!-- q016 -->

            <div v-show="currentTabNo==2" :class="`question_tab_content ${questionIds[1]}`"><!-- q017 -->

              <div class="question_table_wrapper">
                <div class="question_table">
                  <div class="question_table_row">
                    <div class="question_no">{{ params[questionIds[1]].q_no }}</div>
                    <div class="text_container_80 bg-lightyellow">
                      <MyTextBox class="_question_str_90" :canEdit="canEdit" v-model="params[questionIds[1]].question" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="choice_table_wrapper ml-md-5">
                <div class="choice_table">
                  <div class="choice_table_row" v-for="(choiceValue, choiceIdx) in choiceValues[1]" :key="choiceValue">
                    <input type="checkbox" :id="`${questionIds[1]}_${choiceValue}`" class="choice_checkbox" :value="choiceValue" :disabled="!canAnswer"
                            v-model="params[questionIds[1]].answer"
                            :ref="`checkbox_q${questionIds[1]}`"
                            @click="onClickCheckbox(params[questionIds[1]], $refs[`checkbox_q${questionIds[1]}`], $event)"
                            @change="sortCheckboxAnswers(params[questionIds[1]])"
                    />
                    <label :for="`${questionIds[1]}_${choiceValue}`" class="choice_checkbox_placeholder has_value">
                      <div class="choice_value">{{ choiceValue }}：</div>
                    </label>
                    <label :for="`${questionIds[1]}_${choiceValue}`" class="">
                      <MyTextBox class="choice_caption" :canEdit="canEdit" v-model="params[questionIds[1]].choices[choiceIdx]" />
                    </label>
                  </div>
                </div>
              </div>

            </div><!-- q017 -->

            <div v-show="currentTabNo==3" :class="`question_tab_content ${questionIds[2]}`"><!-- q018 -->

              <div class="question_table_wrapper">
                <div class="question_table">
                  <div class="question_table_row">
                    <div class="question_no">{{ params[questionIds[2]].q_no }}</div>
                    <div class="text_container_80 bg-lightyellow">
                      <MyTextBox class="_question_str_90" :canEdit="canEdit" v-model="params[questionIds[2]].question" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="choice_table_wrapper ml-md-5">
                <div class="choice_table">
                  <div class="choice_table_row" v-for="(choiceValue, choiceIdx) in choiceValues[2]" :key="choiceValue">
                    <input type="checkbox" :id="`${questionIds[2]}_${choiceValue}`" class="choice_checkbox" :value="choiceValue" :disabled="!canAnswer"
                            v-model="params[questionIds[2]].answer"
                            :ref="`checkbox_q${questionIds[2]}`"
                            @click="onClickCheckbox(params[questionIds[2]], $refs[`checkbox_q${questionIds[2]}`], $event)"
                            @change="sortCheckboxAnswers(params[questionIds[2]])"
                    />
                    <label :for="`${questionIds[2]}_${choiceValue}`" class="choice_checkbox_placeholder has_value">
                      <div class="choice_value">{{ choiceValue }}：</div>
                    </label>
                    <label :for="`${questionIds[2]}_${choiceValue}`" class="">
                      <MyTextBox class="choice_caption" :canEdit="canEdit" v-model="params[questionIds[2]].choices[choiceIdx]" />
                    </label>
                  </div>
                </div>
              </div>

            </div><!-- q018 -->

            <div v-show="currentTabNo==4" :class="`question_tab_content ${questionIds[3]}`"><!-- q019 -->

              <div class="question_table_wrapper">
                <div class="question_table">
                  <div class="question_table_row">
                    <div class="question_no">{{ params[questionIds[3]].q_no }}</div>
                    <div class="text_container_80 bg-lightyellow">
                      <MyTextBox class="_question_str_90" :canEdit="canEdit" v-model="params[questionIds[3]].question" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="choice_table_wrapper ml-md-5">
                <div class="choice_table">
                  <div class="choice_table_row" v-for="(choiceValue, choiceIdx) in choiceValues[3]" :key="choiceValue">
                    <input type="checkbox" :id="`${questionIds[3]}_${choiceValue}`" class="choice_checkbox" :value="choiceValue" :disabled="!canAnswer"
                            v-model="params[questionIds[3]].answer"
                            :ref="`checkbox_q${questionIds[3]}`"
                            @click="onClickCheckbox(params[questionIds[3]], $refs[`checkbox_q${questionIds[3]}`], $event)"
                            @change="sortCheckboxAnswers(params[questionIds[3]])"
                    />
                    <label :for="`${questionIds[3]}_${choiceValue}`" class="choice_checkbox_placeholder has_value">
                      <div class="choice_value">{{ choiceValue }}：</div>
                    </label>
                    <label :for="`${questionIds[3]}_${choiceValue}`" class="">
                      <MyTextBox class="choice_caption" :canEdit="canEdit" v-model="params[questionIds[3]].choices[choiceIdx]" />
                    </label>
                  </div>
                </div>
              </div>

            </div><!-- q019 -->

          </div><!-- question_tab_contents -->

          <QuestionTabButtons :tabCount="tabCount" v-model="currentTabNo" @input="tabHasBeenChanged=true" />

        </div><!-- question_tabs_wrapper -->

      </div><!-- col -->

    </div><!-- row -->

    <!-- ↑ p01 は単独 -->

    <div v-if="showDescription" class="my-3">

      <hr />

      <div class="description_area_title my-2">【解説】</div>

      <div class="description_tables_wrapper bordered">
        <DescriptionTable :class="questionId" v-for="questionId in questionIds" :key="questionId">
          <template v-slot:q_no>{{ params[questionId].q_no }}</template>
          <template v-slot:answer>正解：{{ getDescAnswerStr(params[questionId]) }}</template>
          <template v-slot:description>
            <MyTextBox :isTextarea="true" :canEdit="canEdit" v-model="params[questionId].description" />
          </template>
        </DescriptionTable>
      </div>

    </div>

  </div>
</template>

<script>
import commonMixin from '../../../common_page';
import QuestionTabButtons from '../../../QuestionTabButtons';
const LogHeader = 'CR-1/練習１/検査２/p01';

export default {
  mixins: [
    commonMixin,
  ],
  components: {
    QuestionTabButtons,
  },
  data() {
    //console.log(`[${LogHeader}] data() CALLED`);
    return {
      questionIds: [ 'q016', 'q017', 'q018', 'q019' ],
      choiceValues: [
        [ 'ア', 'イ', 'ウ', 'エ', 'オ', 'カ', 'キ', 'ク' ],
        [ 'ア', 'イ', 'ウ', 'エ', 'オ', 'カ', 'キ', 'ク' ],
        [ 'ア', 'イ', 'ウ', 'エ', 'オ', 'カ', 'キ', 'ク' ],
        [ 'ア', 'イ', 'ウ', 'エ', 'オ', 'カ', 'キ', 'ク' ],
      ],
      tabCount: 4,
      currentTabNo: 1,
      tabHasBeenChanged: false,
    };
  },
  // created() {
  //   console.log(`[${LogHeader}] created() CALLED`);
  // },
  // mounted() {
  //   console.log(`[${LogHeader}] mounted() CALLED`);
  // },
  activated() {
    console.log(`[${LogHeader}] activated() CALLED`);
  },
  deactivated() {
    console.log(`[${LogHeader}] deactivated() CALLED`);
  },
  methods: {
  },
};
</script>

<style lang="sass" scoped>
</style>
